module.exports = __webpack_public_path__ + "static/media/Soon.4a43623d.webp";